import AddIcon from "@material-ui/icons/Add";
import { styled, Tooltip } from "@material-ui/core";
import { tooltipClasses } from "@mui/material";
const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
    padding: "10px",
    boxShadow: "3px 3px 10px 6px rgba(0, 0, 0, 0.06)",
    fontFamily: "Rajdhani-SemiBold",
  },
}));
const ButtonWithToolTip = ({ buttonText, toolTipText }) => {
  return (
    <HtmlTooltip
      title={
        <div>
          <p className="fs-16">{toolTipText}</p>
        </div>
      }
    >
      <button className="addBtnn2 activv mng-padding">
        <AddIcon className="mx-1 addIconSc " />
        {buttonText}
      </button>
    </HtmlTooltip>
  );
};

export default ButtonWithToolTip;
